import type { HTMLAttributes } from 'react';

import { cn } from '../lib/cn';

import s from './FormError.module.css';

interface FormErrorProps extends HTMLAttributes<HTMLParagraphElement> {
  message?: string | undefined;
}

export function FormError({ message, className, id, ...rest }: FormErrorProps): JSX.Element | null {
  if (message === undefined || message.length === 0) return null;
  return (
    <p id={id} role="alert" className={cn(s.root, className)} {...rest}>
      <span className={s.dot} aria-hidden="true" />
      <span>{message}</span>
    </p>
  );
}
